import ReferralResume from '@/views/Referral/ReferralResume/ReferralResume.vue';
import flagKeys from '@/constants/flagKeys';

import { Route } from '../route.model';
import { IBusinessType } from '@/models/business';
import { referralProgramValidator } from '../validators/navbar';

const referralProgram = new Route(
  '/referral-program',
  'referral-program',
  ReferralResume,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    flag: flagKeys.businessReferral,
    validator: () => referralProgramValidator(),
    navbar: {
      name: 'Referral Program', // TODO apply i18n
      icon: 'referral',
      description:
        'Reward members for promoting your business with Coins and discounts.'
    },
    pageView: {
      eventLabel: 'Referral Program'
    },
    feature: {
      type: IBusinessType.ONLINE
    },
    needProviderConnected: true
  }
);

export { referralProgram };
export default referralProgram;
